import { render, staticRenderFns } from "./PriceWithDetails.vue?vue&type=template&id=76d538f1"
import script from "./PriceWithDetails.vue?vue&type=script&lang=ts"
export * from "./PriceWithDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports